const TrunkStatuses = {
    0: {
        type: 'active',
        displayedName: 'OK',
    },
    1: {
        type: 'processing',
        displayedName: 'Adding',
        toolTip: 'Trunk is being added',
    },
    3: {
        type: 'action',
        displayedName: 'Pending Approval',
        toolTip: 'Awaiting approval',
    },
    4: {
        type: 'processing',
        displayedName: 'Updating',
        toolTip: 'Trunk is being updated',
    },
    8: {
        type: 'processing',
        displayedName: 'Degraded',
        toolTip: 'Trunk is in degraded state',
    },
    9: {
        type: 'disabled',
        displayedName: 'Deleting',
        toolTip: 'Trunk is being deleted',
    },
    20: {
        type: 'error',
        displayedName: 'Error',
    },
};

export default TrunkStatuses;
